import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux";
import { Button, Label } from "reactstrap";
import { useNavigate } from "react-router";
import CompanyProfile from "pages/UserPreferences/Settings/CompanyProfile";
import AdminNotificationSettings from "./AdminNotificationSettings";
import AdminSkillsSettings from "./AdminSkillsSettings";

const menuItems = [
    { label: "userpreferences.company_profile", icon: "ri-hotel-fill", category: "general", key: "company_profile" },
    { label: "Notification Controls", icon: "ri-shield-keyhole-fill", category: "general", key: "notification_controls" },
    { label: "Skills Controls", icon: "ri-shield-keyhole-fill", category: "general", key: "skills_controls" },
];

const groupedItems = menuItems.reduce((acc: Record<string, typeof menuItems>, item) => {
    acc[item.category] = acc[item.category] || [];
    acc[item.category].push(item);
    return acc;
}, {});

const WorkspaceSettings = ({ t }: any) => {
    const navigate = useNavigate();

    const [activeItem, setActiveItem] = useState<string>("company_profile");

        const goBack = () => {
        navigate(-1);
    };
    
    const Sidebar = ({ t, goBack }: any) => (
        <aside className="d-flex flex-column vh-100 p-3" style={{ minWidth: "250px" }}>
            <div className="text-primary mb-3">
                <div>
                    <Button outline color="primary" className="btn-sm ms-n3 hstack btn-ghost-primary align-items-center fw-bold fs-14" onClick={() => goBack()}>
                        <i className="ri-arrow-left-s-line"></i><span>Back</span>
                    </Button>
                </div>
            </div>
            <nav className="flex-grow-1">
                {Object.entries(groupedItems).map(([category, items]) => (
                    <div key={category} className="mb-3">
                        <div className="text-uppercase fw-semibold text-muted small mb-2">
                            <Label className="mb-0">{t(`${category}`) || category}</Label>
                        </div>
                        {items.map(({ label, icon, key }) => (
                            <div
                                key={label}
                                onClick={() => setActiveItem(key)}
                                className={`rounded p-2 d-flex align-items-center mb-2 ${activeItem === key ? "bg-primary-subtle text-muted" : "bg-light-subtle"}`}
                                style={{ cursor: "pointer" }}
                            >
                                <Button color="light" className={`btn-icon btn-sm me-2 ${activeItem === key ? "bg-light-subtle text-muted" : "bg-primary-subtle"}`}> <i className={`${icon} text-primary fs-5`}></i> </Button>
                                
                                <span><Label className="mb-0">{t(label)}</Label></span>
                            </div>
                        ))}
                    </div>
                ))}
            </nav>
        </aside>
    );

    return (
        <div className="d-flex bg-light-subtle rounded-3" style={{ minHeight: "100vh" }}>
            <Sidebar t={t} goBack={goBack} />
            <div className="flex-grow-1 d-flex flex-column me-n2">
                <main className="p-0 bg-light flex-grow-1">
                    {activeItem === "company_profile" && <CompanyProfile />}
                    {activeItem === "notification_controls" && <AdminNotificationSettings />}
                    {activeItem === "skills_controls" && <AdminSkillsSettings />}
                </main>
            </div>
        </div>
    )
}
export default withTranslation()(WorkspaceSettings)